module.exports = __webpack_public_path__ + "static/media/icon-save-blue.a07cd169.svg";